import { writable } from "svelte/store";

export const notification = writable(null);

/**
 * Add a notification message
 *
 * @param {string} message
 */
export function notify(message = "") {
  notification.set(message);
}
